import { FieldType, Item } from 'public/app/models/Item';

export enum FilterType {
  Contain,
  Exclude,
  Range
}

export class FilteringModule {
  constructor() {
  }

  sort(fieldType: FieldType, filterType: FilterType, arg: Array<any>,  items: Array<Item>): Array<Item> {
    let ret = Array<Item>();
    if ((fieldType === FieldType.LastEntry) || (fieldType === FieldType.PurchaseDate))  {
      filterType = FilterType.Range;
    }
    switch (filterType) {
      case FilterType.Contain:
        ret = this.sortContain(fieldType, items, arg[0], false);
        break;

      case FilterType.Exclude:
        ret = this.sortContain(fieldType, items, arg[0], true);
        break;

      case FilterType.Range:
        ret = this.sortRange(fieldType, items, arg[0], arg[1]);
        break;
    }
    return ret;
  }

  sortContain(fieldType: FieldType, items: Array<Item>, data, exclude: boolean): Array<Item>  {
    return items.filter( field =>  {
      try {
        switch (fieldType) {
          case FieldType.Category:
            return exclude !== field.CATEGORY.includes(data);
          case FieldType.Description:
            return exclude !== field.DESCRIPTION.includes(data);
          case FieldType.LastUser:
            return exclude !== (field.USERNAME.includes(data) || field.USERSURNAME.includes(data)) ;
          case FieldType.Location:
            return exclude !== field.LOCATION.includes(data);
          case FieldType.Mark:
            return exclude !== field.MARK.includes(data);
          case FieldType.Remarks:
            return exclude !== field.REMARKS.includes(data);
          case FieldType.State:
            return exclude !== field.STATE.includes(data);
          case FieldType.Title:
            return exclude !== field.TITLE.includes(data);
        }
      } catch {
            return false;
        }
    });
  }

  sortRange(fieldType: FieldType, items: Array<Item>, r1, r2): Array<Item> {
    return items.filter( field =>  {
      try {
        switch (fieldType) {
          case FieldType.LastEntry:
            return (((field.EDIT_DATETIME as any).toDate() >= r1) && ((field.EDIT_DATETIME as any).toDate() <= r2));
          case FieldType.PurchaseDate:
            return (((field.EDIT_DATETIME as any).toDate() >= r1) && ((field.EDIT_DATETIME as any).toDate() <= r2));
          }
        } catch {
            return false;
        }
    });
  }

}

